import { Box } from "@mui/material";
import TodoNote from "@/components/todos/todoNote"
import TodoImageThumbnails from "@/components/todos/todoImageThumbnails"
import styles from "@/components/todos/todoNoteImageThumbnailsWrapper.module.css";

interface TodoNoteImageThumbnailsWrapperProps {
  note?: {
    payload: string;
  };
  images?: Array<{
    id: string;
    name: string;
    view_link: string;
    download_link: string;
    extension: string;
  }>;
  onImageClick: (imageIndex: number) => void;
  childrenSubjectId?: string;
  customThumbnailimageAlt?: string;
}

export default function TodoNoteImageThumbnailsWrapper({
  note,
  images,
  onImageClick,
  childrenSubjectId,
  customThumbnailimageAlt
}: TodoNoteImageThumbnailsWrapperProps) {
  const hasNote = note && note.payload;
  const hasImages = images && images.length > 0;

  if (!hasNote && !hasImages) {
    return null;
  }

  return (
    <Box className={styles.todoNoteImageThumbnailsWrapperContainer}>
      {hasNote && <TodoNote note={note} />}
      {hasImages && (
        <TodoImageThumbnails
          images={images}
          onImageClick={onImageClick}
          childrenSubjectId={childrenSubjectId}
          customThumbnailimageAlt={customThumbnailimageAlt}
        />
      )}
    </Box>
  );
}
